function initSearch() {
  const menuSearchItem = document.querySelector( '.mega-menu-item.menu-search' );
  if ( ! menuSearchItem ) return;

  const menuTitle = menuSearchItem.querySelector( '.mega-menu-title' );
  const searchClose = menuSearchItem.querySelector( '.search-close' );
  const searchInput = menuSearchItem.querySelector( '.search-input' );
  if ( ! menuTitle || ! searchInput ) return;

  const originalPlaceholder = searchInput.getAttribute( 'data-placeholder' ) || 'Search...';
  const body = document.body;

  const toggleSearchCloseVisibility = () => {
    if ( ! searchClose ) return;
    if ( searchInput.value.trim().length > 0 ) {
      searchClose.classList.add( 'is-visible' );
    } else {
      searchClose.classList.remove( 'is-visible' );
    }
  };

  const openSearch = () => {
    const megaDescriptionGroup = menuSearchItem.querySelector( '.mega-description-group' );
    if ( megaDescriptionGroup ) megaDescriptionGroup.classList.add( 'active-search' );
    searchInput.focus();
    body.style.overflow = 'hidden';
    toggleSearchCloseVisibility();
  };

  const clearSearchForm = () => {
    searchInput.value = '';
    searchInput.focus();
    toggleSearchCloseVisibility();
  };

  const closeSearch = () => {
    const megaDescriptionGroup = menuSearchItem.querySelector( '.mega-description-group' );
    if ( megaDescriptionGroup ) megaDescriptionGroup.classList.remove( 'active-search' );
    body.style.overflow = '';
    searchInput.value = '';
    document.activeElement?.blur?.();
  };

  menuTitle.addEventListener( 'click', openSearch );

  bindSearchClose( searchClose, clearSearchForm );
  searchInput.addEventListener( 'input', toggleSearchCloseVisibility );
  attachSubmitIcon( menuSearchItem );
  bindEscapeKey( closeSearch );
  bindPopupCloseOnly( menuSearchItem, closeSearch );
  setupPlaceholderObserver( searchInput, originalPlaceholder );
  fixInitialPlaceholder( searchInput );
  toggleSearchCloseVisibility();
}

function bindSearchClose( searchClose, clearSearchForm ) {
  if ( ! searchClose ) return;
  searchClose.addEventListener( 'click', ( e ) => {
    e.preventDefault();
    e.stopPropagation();
    clearSearchForm();
  } );
}

function attachSubmitIcon( menuSearchItem ) {
  const form = menuSearchItem.querySelector( 'form' );
  if ( ! form ) return;
  const searchSubmitIcon = document.createElement( 'span' );
  searchSubmitIcon.classList.add( 'search-submit-icon' );
  form.appendChild( searchSubmitIcon );
  searchSubmitIcon.addEventListener( 'click', ( e ) => {
    e.preventDefault();
    form.submit();
  } );
}

function bindEscapeKey( closeSearch ) {
  document.addEventListener( 'keydown', ( e ) => {
    if ( e.key !== 'Escape' ) return;
    closeSearch();
  } );
}

function bindPopupCloseOnly( menuSearchItem, closeSearch ) {
  const megaDescription = menuSearchItem.querySelector( '.mega-menu-description' );
  if ( ! megaDescription ) return;

  let popupCloseBtn = megaDescription.querySelector( '.popup-close-btn' );
  if ( ! popupCloseBtn ) {
    popupCloseBtn = document.createElement( 'span' );
    popupCloseBtn.classList.add( 'popup-close-btn' );
    megaDescription.appendChild( popupCloseBtn );
  }
  popupCloseBtn.addEventListener( 'click', ( e ) => {
    e.preventDefault();
    e.stopPropagation();
    closeSearch();
  } );
}

function setupPlaceholderObserver( searchInput, originalPlaceholder ) {
  const observer = new MutationObserver( ( mutationsList ) => {
    for ( const mutation of mutationsList ) {
      if ( mutation.type !== 'attributes' || mutation.attributeName !== 'placeholder' ) continue;
      if ( searchInput.getAttribute( 'placeholder' ) !== '' ) continue;
      searchInput.setAttribute( 'placeholder', originalPlaceholder );
    }
  } );
  observer.observe( searchInput, { attributes: true } );
}

function fixInitialPlaceholder( searchInput ) {
  const p = searchInput.getAttribute( 'placeholder' );
  if ( p !== '' && p !== 's' ) return;
  searchInput.setAttribute( 'placeholder', 'Search...' );
}

document.addEventListener( 'DOMContentLoaded', initSearch );
